module.exports = __webpack_public_path__ + "img/es.7475d3c8.svg";